import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ADD_MAILING_LIST_FORM_STEPS} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Strings from "../../../../../resources/Strings";
import * as messagingActionsService from "../../../../../services/ActionsService/MessagingActionsService";
import { getSitesUnderSelectedScope } from "../../../../../utils/UsersUtils";
import {
  showDiscardChangesMessage,
  showErrorMessage,
  showUpdateSuccessMessage
} from "../../../../../utils/MessagesUtils";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import classes from "../WizardForm.module.css";
import MailingListDetailsStep from "../Steps/MailingListDetailsStep";
import { MailingListEntity } from "../../../../../entities/ServicesEntities/MessagingEntities/MailingListEntity";
import { MailingListToUserEntity } from "../../../../../entities/ServicesEntities/MessagingEntities/MailingListToUserEntity";

import { messagingActions } from "../../../../../redux/reducers/MessagingReducer";
import { getMailingListData } from "../../../../../utils/MessagingUtils";

const AddMailingListForm = (props) => {
  const gmtUser = useSelector((state) => state.user.gmtUser);
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const allScopes = useSelector((state) => state.user?.allScopes);
  const sites = useSelector((state) => state.user?.sites);
  const selectedSites = getSitesUnderSelectedScope(sites, allScopes, selectedScope);

  const [formData, setFormData] = useState({
    mailingListName: props?.isEditMode ? props.name : "",
    mailingListParkers: [],
    isStepSubmitted: false
  });

  const [stateData, setStateData] = useState({
    currentStep: ADD_MAILING_LIST_FORM_STEPS.MAILING_LIST_DETAILS,
    totalSteps: 1,
    isCurrentStepValid: false,
    isCurrentStepHasValues: false
  });

  const [initialFormData, setInitialFormData] = useState({...formData});
  const isOpenChangesExists = useSelector((state) => state.common.isOpenChangesExists);
  const sideModal = useSelector((state) => state.common.sideModal);

  useEffect(() => {
    // handle save changes modal checks only on create new mailing list
    if (!props.isEditMode) {
      let localIsOpenChangesExists = false;
  
      if (!isOpenChangesExists && (
        initialFormData.mailingListName !== formData.mailingListName ||
        initialFormData.mailingListParkers?.length < formData.mailingListParkers?.length)) {
        localIsOpenChangesExists = true;
      }
  
      // once user changed an input, set modalCloseMessage, and set isOpenChangesExists true to disable next checks
      if (localIsOpenChangesExists && !isOpenChangesExists && sideModal?.modalCloseMessage === null) {
        store.dispatch(commonActions.setSideModal({modalCloseMessage: showDiscardChangesMessage}));
        store.dispatch(commonActions.setIsOpenChangesExists(true));
      }
  
      return () => {
        // unmount - on form close reset changes indication back to false
        store.dispatch(commonActions.setIsOpenChangesExists(false));
      }
    }
  }, [formData]);

  const handleChange = (newProp) => {
    setFormData({ ...formData, ...newProp });
  };

  const handleStateDataChange = (newProp) => {
    setStateData({ ...stateData, ...newProp });
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    const { mailingListName, mailingListParkers } = formData;

    if (stateData.isCurrentStepValid) {
      let action = null;

      const mailingListToUsersByRecipients = mailingListParkers?.map(parker => new MailingListToUserEntity(
        0,
        props?.isEditMode ? props.id : 0,
        parker?.identifierId
      ));

      const mailingList = new MailingListEntity(
        props?.isEditMode ? props.id : 0, 
        mailingListName, 
        new Date(), 
        gmtUser?.utronUser?.id, 
        selectedSites?.[0]?.id,
        mailingListToUsersByRecipients
      );
  
      if (props?.isEditMode) {
        // update
        action = messagingActionsService.updateMailingList(mailingList);
      } else {
        // add
        action = messagingActionsService.addMailingList(mailingList);
      }
      
      action.then(response => {
        if (response.data.isSuccess) {
          let mailingListsData = getMailingListData(response.data.entity, selectedSites?.[0]);
          let updatedSelectionModel = mailingListsData?.mailingLists.find(ml => ml.id === props.id);
          
          // update mailing list
          store.dispatch(messagingActions.setMailingListsData(mailingListsData));

          // update the selected opened mailig list on info window
          store.dispatch(messagingActions.setMessagingSelectionModel(updatedSelectionModel));
          showUpdateSuccessMessage();

          // close side modal
          store.dispatch(commonActions.closeSideModal());
        }
        else {
          showErrorMessage(response.data?.error);
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        }
      }).catch(error => {
        showErrorMessage(error);
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      });
    }
  };

  const skip = () => {
    store.dispatch(commonActions.closeSideModal());
  };

  return (
    <form name="AddMailingListForm" onSubmit={handleSubmit}>
      <div className={classes.formContainer}>
        <div className={classes.stepContainer}>
          <MailingListDetailsStep 
            isEditMode={props?.isEditMode}
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleStateDataChange={handleStateDataChange}
            {...formData}
            {...props}
          />
        </div>
        <div className={classes.next}>
            <EllipseButton onClick={handleSubmit} disabled={!stateData.isCurrentStepHasValues}>{Strings.SAVE_LIST}</EllipseButton>
            <EllipseButton onClick={skip} isCancelButton={true} >{Strings.CANCEL}</EllipseButton>
        </div>
      </div>
    </form>
  );
};

export default AddMailingListForm;
